export class Token {
  access_token: string;
}



// WEBPACK FOOTER //
// /app/src/app/entities/token.entity.ts